import { useEffect } from "react";

import { buildRoute } from "sj-ui-toolkit/src/constants/routes";
import { useSmartNavigation } from "sj-ui-toolkit/src/helpers/navigation";

const ProfileAchievementRedirect = () => {
  const { navigateTo } = useSmartNavigation();

  useEffect(() => {
    navigateTo(buildRoute("User.routes.achievements.route"));
  }, [navigateTo]);

  return null;
};

export default ProfileAchievementRedirect;
